import type { CountryInfo, SupportedCountry } from '../types';

export const countriesList: Record<SupportedCountry, CountryInfo> = {
    NZ: {
        shortName: 'NZ',
        name: 'New Zealand',
        nameCasual: 'New Zealand',
        domain: 'archipro.co.nz',
    },
    AU: {
        shortName: 'AU',
        name: 'Australia',
        nameCasual: 'Australia',
        domain: 'archipro.com.au',
    },
    US: {
        shortName: 'US',
        name: 'America',
        nameCasual: 'the USA',
        domain: 'archiproamerica.com',
    },
};

/**
 * Replaces the full country domain in a hostname.
 * Handles production domains (archipro.co.nz, archiproamerica.com)
 * and prefixed environments (dev.archipro.co.nz, bc-1234.dev.archiproamerica.com).
 */
export const swapDomain = (
    host: string,
    fromCountry: SupportedCountry,
    toCountry: SupportedCountry,
): string => {
    const fromDomain = countriesList[fromCountry].domain;
    const toDomain = countriesList[toCountry].domain;
    return host.replace(fromDomain, toDomain);
};
